<template>
  <div class="honor-wall-popup" v-show="show">
    <div class="popup-cont">
      <i class="popup-close" @click="close"></i>
      <div class="popup-img"></div>
      <div class="honor-list">
        <ul>
          <li v-for="(item,index) in data.glorys" :key="index">
            <img :src="item.lock?item.image:noHonor" alt="">
            <p v-if="!item.lock">{{imgList[index].num}}门课<br/>解锁</p>
          </li>
        </ul>
        <p class="honor-course">已学完 {{data.finishCourseCount}} 门课，{{data.nextTargetGapNum === 0 ? "解锁了全部荣誉~" : '离下一目标还差'+ Math.abs(data.nextTargetGapNum) +'门课' }}</p>
        <div class="honor-share" @mouseover="shareQrcodeShow" @mouseout="shareQrcodeHide">分享</div>
      </div>
      <div class="QRCode-box" v-if="shareQrcodeFlag">
        <div class="qrcode">
          <img :src="qrCode" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { zhugeTrack } from "@/../public/public";
export default {
  props:['show','data','qrCode'],
  data() {
    return {
      noHonor:require("@/image/pic-honor-no.png"),
      imgList:[
        {num:1},
        {num:2},
        {num:5},
        {num:10}
      ],
      shareQrcodeFlag: false
    }
  },
  methods:{
    close(){
      this.$emit('closePopup')
    },
    shareQrcodeShow(){
      this.shareQrcodeFlag = true
      zhugeTrack('Web_当前学习页-分享荣誉墙')
    },
    shareQrcodeHide(){
      this.shareQrcodeFlag = false
    }
  }
}
</script>

<style lang="less" scoped>
  .honor-wall-popup{
    width: 100%;
    height: 100%;
    position: fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,.3);
    z-index:20;
    .popup-cont{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 500px;
      background: #25C48B;
      border-radius: 8px;
      padding: 80px 20px 20px;
      .popup-close{
        position: absolute;
        top:32px;
        right: 25px;
        width: 15px;
        height: 15px;
        cursor: pointer;
        background-image:url(../../image/icon-close-w.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        &:hover{
          background-image:url(../../image/icon-close-w-h.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .popup-img{
        width: 120px;
        height: 110px;
        border-radius: 50%;
        background-image:url(../../image/pic-honor.png);
        background-size: 95px 88px;
        background-repeat: no-repeat;
        background-position:12.5px 5px;
        background-color: #25C48B;
        position: absolute;
        top:0;
        left:50%;
        transform: translateX(-50%);
        z-index:21;
      }
      .honor-list{
        background: #fff;
        border-radius: 8px;
        padding-top: 40px;
        padding-bottom: 30px;
        ul{
          width: 330px;
          margin: 0 auto;
          li{
            width: 125px;
            height: 128px;
            float:left;
            margin-right: 80px;
            margin-bottom: 30px;
            position: relative;
            img{
              width: 100%;
              height: 100%;
            }
            p{
              width: 53px;
              height: 36px;
              top:50%;
              left: 50%;
              transform: translate(-50%,-50%);
              position: absolute;
              z-index:2;
              text-align: center;
              line-height: 18px;
              color:#D1D1D1;
              font-size: 13px;
            }
          }
          &::after{
            display: block;
            content: '';
            clear: both;
          }
          li:nth-of-(1),li:nth-of-(2){
            margin-top:0;
          }
          li:nth-of-type(2n){
            margin-right:0;
          }
        }
        .honor-course{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          line-height: 20px;
          color: #2a3c60;
          text-align: center;
          margin-top: 14px;
        }
        .honor-share{
          width: 90px;
          height: 36px;
          margin: 40px auto 0;
          font-size:14px;
          line-height:14px;
          color: #fff;
          text-align: center;
          line-height: 36px;
          border-radius: 4px;
          background-color: #e88f34;
          cursor: pointer;
          &:hover{
            background: #FFB66C;
          }
        }
      }
      .QRCode-box{
        position: absolute;
        bottom: 100px;
        width: 152px;
        height: 152px;
        left:50%;
        transform: translateX(-50%);
        background: #25C48B;
        padding: 6px;
        box-sizing: border-box;
        border-radius: 8px;
        z-index:5;
        .qrcode{
          width: 140px;
          height: 140px;
          background: #fff;
          border-radius: 4px;
          padding:5px;
          box-sizing: border-box;
          img{
            width: 130px;
            height: 130px;
            border-radius: 4px;
          }
        }
      }
    }
  }
</style>